import { render, staticRenderFns } from "./thesisAudit.vue?vue&type=template&id=3f8affaa&scoped=true&"
import script from "./thesisAudit.vue?vue&type=script&lang=js&"
export * from "./thesisAudit.vue?vue&type=script&lang=js&"
import style0 from "./thesisAudit.vue?vue&type=style&index=0&id=3f8affaa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8affaa",
  null
  
)

export default component.exports